/** Normalizações de texto compartilhadas pelas meta tags. */

/** O Plone insere hífen suave para quebra de linha; em meta tag vira sujeira. */
export const withoutSoftHyphen = (text?: string | null): string =>
  (text ?? '').replace(/­/g, '');

/** Atributo de meta tag é uma linha só; `schema.Text` aceita quebras. */
export const singleLine = (text?: string | null): string =>
  withoutSoftHyphen(text).replace(/\s+/g, ' ').trim();

/** Campo `Choice` serializado vem como `{token, title}`; cru, como string. */
export const tokenOf = (field: any): string | undefined =>
  typeof field === 'string' ? field : field?.token;

export const titleOf = (field: any): string | undefined =>
  typeof field === 'string' ? field : field?.title;
